<script>
  export let weekNo;
  import { _ } from "svelte-i18n";
</script>

<div class="calendar-week-overview">
  <div class="calendar-week__number">
    <a
      role="link"
      tabindex="0"
      class="calendar-week__load-button"
      style="cursor: pointer;"
    /><span class="calendar-week__number-text">{weekNo}</span>
  </div>
  <div class="calendar-week-overview__inner-wrap">
    <div class="progress progress--week">
      <div>
        <div class="progress__label">
          <span
            ><strong>0 {$_("profile.securityCopy.sessions")}.</strong> 0 {$_(
              "plans.planned"
            )}.</span
          ><span>0 {$_("weekplan.inYearPlan")}.</span>
        </div>
        <div class="progress__bar">
          <div
            class="progress__bar-done progress__bar-done--afterDone"
            style="width: 20%;"
          />
          <div class="progress__bar-planned" style="left: 100%;" />
          <div class="progress__bar-track" />
        </div>
        <div />
      </div>
      <div>
        <div class="progress__label">
          <span
            ><strong> {$_("weekplan.hours")}.</strong>
            {$_("plans.planned")}.</span
          ><span>0 {$_("weekplan.inYearPlan")}.</span>
        </div>
        <div class="progress__bar">
          <div
            class="progress__bar-done progress__bar-done--afterDone"
            style="width: 27%;"
          />
          <div class="progress__bar-planned" style="left: 100%;" />
          <div class="progress__bar-track" />
        </div>
        <div />
      </div>
    </div>
    <div class="micrograph micrograph--week">
      <span class="micrograph__label">{$_("weekplan.distrobution")}</span>
      <ul class="micrograph__list-bars">
        <li class="micrograph__izone micrograph__izone--1-three-izones">
          <span class="micrograph__planned" style="height: 0%;" /><span
            class="micrograph__done"
            style="height: 0%;"
          />
        </li>
        <li class="micrograph__izone micrograph__izone--2-three-izones">
          <span class="micrograph__planned" style="height: 0%;" /><span
            class="micrograph__done"
            style="height: 0%;"
          />
        </li>
        <li class="micrograph__izone micrograph__izone--3-three-izones">
          <span class="micrograph__planned" style="height: 0%;" /><span
            class="micrograph__done"
            style="height: 0%;"
          />
        </li>
      </ul>
    </div>
  </div>
</div>
